// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".add-to-cart-dialog[data-v-098f9f56]{overflow-y:auto}.border-dashed[data-v-098f9f56]{border-bottom:1px dashed #b9b9b9}.bg-gray-light[data-v-098f9f56]{background-color:#f0f0f0}.variant-quantity[data-v-098f9f56]{background-color:#fff;height:60px;overflow:hidden}.border-right[data-v-098f9f56]{border-color:#b7b7b7}.border-left[data-v-098f9f56]{border-left:1px solid #b7b7b7}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
